import React from 'react';
import { EditorContent as TiptapEditorContent } from '@tiptap/react';
import { Editor } from '@tiptap/core';

import { TCollabThread } from '@tiptap-pro/provider';

import { TableWrapper } from 'containers/Tiptap/components/tiptap-ui/table-wrapper';

import { SidebarEnum } from 'containers/Tiptap/components/tiptap-templates/types';
import { computeMarginRight } from 'containers/Tiptap/components/tiptap-templates/utils';
import { ThreadsProvider } from 'containers/Tiptap/components/tiptap-templates/ThreadContext';

interface EditorContentWrapperProps {
  editor: Editor;
  threads: TCollabThread[];
  selectedThread: string | null;
  selectedThreads: string[];
  activeSidebar: SidebarEnum | false;
  windowWidth: number;
  onDeleteThread: (threadId: string) => void;
  onHoverThread: (threadId: string) => void;
  onLeaveThread: () => void;
  onResolveThread: (threadId: string) => void;
  onUnresolveThread: (threadId: string) => void;
  onUpdateComment: (
    threadId: string,
    commentId: string,
    content: string,
    metaData: Record<string, unknown> | undefined
  ) => void;
  onClickThread: (threadId: string) => void;
  setSelectedThread: (threadId: string | null | ((currentThreadId: string | null) => string | null)) => void;
  children?: React.ReactNode;
}

export const EditorContentWrapper: React.FC<EditorContentWrapperProps> = ({
  editor,
  threads,
  selectedThread,
  selectedThreads,
  activeSidebar,
  windowWidth,
  onDeleteThread,
  onHoverThread,
  onLeaveThread,
  onResolveThread,
  onUnresolveThread,
  onUpdateComment,
  onClickThread,
  setSelectedThread,
  children,
}) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'row',
      gap: '16px',
      marginRight: computeMarginRight(activeSidebar, selectedThread, windowWidth),
    }}
  >
    <ThreadsProvider
      threads={threads}
      onDeleteThread={onDeleteThread}
      onHoverThread={onHoverThread}
      onLeaveThread={onLeaveThread}
      onResolveThread={onResolveThread}
      onUpdateComment={onUpdateComment}
      selectedThread={selectedThread}
      onUnresolveThread={onUnresolveThread}
      onClickThread={onClickThread}
      setSelectedThread={setSelectedThread}
      selectedThreads={selectedThreads}
    >
      <TableWrapper editor={editor}>
        <TiptapEditorContent editor={editor} className="simple-editor-content" />
      </TableWrapper>

      {children}
    </ThreadsProvider>
  </div>
);
